import { render, staticRenderFns } from "./PagsmileCard.vue?vue&type=template&id=c1e802ae&scoped=true&"
import script from "./PagsmileCard.vue?vue&type=script&lang=js&"
export * from "./PagsmileCard.vue?vue&type=script&lang=js&"
import style0 from "./PagsmileCard.vue?vue&type=style&index=0&id=c1e802ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e802ae",
  null
  
)

export default component.exports